export default __webpack_public_path__ + "static/media/BackButton.89d4611e.svg";